import Phaser from "phaser";

export default class BootScene extends Phaser.Scene {
  private loadingText!: Phaser.GameObjects.Text;
  private progressBarBg!: Phaser.GameObjects.Rectangle;
  private progressBar!: Phaser.GameObjects.Rectangle;
  private progressText!: Phaser.GameObjects.Text;

  constructor() {
    super("BootScene");
  }

  preload() {
    const w = this.scale.width;
    const h = this.scale.height;

    // ローディング表示（フォントは既に読み込まれているので、最初からKirangHaerangを指定）
    this.loadingText = this.add.text(
      w / 2,
      h / 2 - 60,
      "Loading...",
      { fontFamily: "KirangHaerang", fontSize: "48px", color: "#ffffff" }
    );
    this.loadingText.setFontFamily("KirangHaerang");
    this.loadingText.setOrigin(0.5);

    // 進捗バーの背景
    const barWidth = Math.min(w * 0.6, 400);
    const barHeight = 20;
    const barX = w / 2;
    const barY = h / 2 + 20;

    this.progressBarBg = this.add.rectangle(barX, barY, barWidth, barHeight, 0x333333);
    this.progressBarBg.setOrigin(0.5, 0.5);

    // 進捗バー
    this.progressBar = this.add.rectangle(barX - barWidth / 2, barY, 0, barHeight, 0x00ff88);
    this.progressBar.setOrigin(0, 0.5);

    // 進捗テキスト（フォントは既に読み込まれているので、最初からKirangHaerangを指定）
    this.progressText = this.add.text(
      barX,
      barY + 40,
      "0%",
      { fontFamily: "KirangHaerang", fontSize: "32px", color: "#ffffff" }
    );
    this.progressText.setFontFamily("KirangHaerang");
    this.progressText.setOrigin(0.5);

    // 進捗イベント
    this.load.on("progress", (value: number) => {
      const progressWidth = barWidth * value;
      this.progressBar.width = progressWidth;
      this.progressBar.x = barX - barWidth / 2;
      this.progressText.setText(`${Math.round(value * 100)}%`);
    });

    // 最初に必要な画像だけ読み込む
    // 背景画像
    this.load.image("bg", "assets/img/bg.png");
    // ロゴ画像
    this.load.image("logo", "assets/img/logo.png");
    // アイコン画像
    this.load.image("iconStopWatch", "assets/img/icon_stop_watch.png");
    this.load.image("iconGame", "assets/img/icon_game.png");
    this.load.image("iconClear", "assets/img/icon_clear.png");
    // 音声ファイル
    this.load.audio("bgm", "assets/audio/bgm.mp3");
    this.load.audio("sfxMove", "assets/audio/move.mp3");
    this.load.audio("sfxFinish", "assets/audio/finish.mp3");
    this.load.audio("sfxButton", "assets/audio/button.mp3");
    this.load.audio("bgmGameOver", "assets/audio/game_over.mp3");

    // puzzle画像は遅延読み込み（GameSceneで必要時に読み込む）
  }

  create() {
    console.log("[BootScene] create() メソッドが実行されました");
    this.game.registry.set("defaultTextStyle", {
      fontFamily: "KirangHaerang",
      fontSize: "48px",
      color: "#ffffff",
    });

    // フォントは既にcreateGame.tsで読み込まれているので、すぐにSceneを開始できる
    console.log("[BootScene] UISceneを起動します");
    this.scene.launch("UIScene");
    console.log("[BootScene] GameSceneを開始します");
    this.scene.start("GameScene");
    
    // モード選択画面が表示されるまでローディングを表示し続ける
    const uiScene = this.scene.get("UIScene");
    if (uiScene) {
      uiScene.events.once("modeSelectReady", () => {
        console.log("[BootScene] モード選択画面の準備が完了しました");
        // ローディング表示を削除
        this.loadingText.destroy();
        this.progressBarBg.destroy();
        this.progressBar.destroy();
        this.progressText.destroy();
      });
    }
  }
}

